const initialState = {
  list: [],
  addStatus: null,
  info: null,
  updatedOrders: false
};

const reducer = (state = initialState, action) => {
  let newState = { ...state };

  switch (action.type) {
    case "GET_USER_ORDERS":
      newState = {
        ...state,
        list: action.value,
        info: null,
        updatedOrders: true
      }
      break;
    case "LOADING_ORDERS":
      newState = {
        ...state,
        info: 'loading...',
      }
      break;
    case "SUCCESS_ON_ORDERS":
      newState = {
        ...state,
        info: 'Success',
        updatedOrders: false
      }
      break;
    case "ERROR_ON_ORDERS":
      newState = {
        ...state,
        info: 'Try Again',
      }
      break;
    case "RESET_ORDER_STATUS":
      newState = {
        ...state,
        addStatus: null
      }
      break;

    default:
  }
  return newState;
};

export default reducer;
